import React from 'react';
import PropTypes from 'prop-types';
import UserAvatar from 'components/pure/utils/UserAvatar';
import GenericTooltip from 'components/pure/tooltips/GenericTooltip';
import CoachingReview from 'records/CoachingReview';
import './UpcomingAgendaHeader.styl';
import moment from 'moment';
import User from 'records/User';
import {CalendarDaysIcon} from '@components/icon/CalendarDaysIcon';
import {LocationDotIcon} from '@components/icon/LocationDotIcon';

export default class UpcomingAgendaHeader extends React.PureComponent {
  constructor(props) {
    super(props);
    this.state = {dateMouseover: false};
  }

  render() {
    const {review, otherUser, horizontal} = this.props;
    const {dateMouseover} = this.state;
    const location = (review.meetingType && review.meetingType.detail()) || 'Virtual meeting';
    const overdue = moment().isAfter(review.scheduleAt);

    return (
      <div className="upcoming-agenda-header">
        <div className={`user-info ${horizontal && 'horizontal'}`}>
          <UserAvatar user={otherUser} />
          <div className="name-wrapper">
            <strong>{otherUser.getFullName()}</strong>
          </div>
        </div>
        <div className="meeting-info">
          {dateMouseover && overdue && <span className="overdue-banner">PAST-DUE</span>}
          <div className={`agenda-review-time ${overdue && 'overdue'}`}>
            <CalendarDaysIcon tooltip="Time" />
            <span
              onMouseEnter={() => this.setState({dateMouseover: true})}
              onMouseLeave={() => this.setState({dateMouseover: false})}>
              {review.scheduleAt.format('ddd, M/D/YY, h:mmA')}
            </span>
          </div>
          <div className="review-location">
            <LocationDotIcon tooltip="Location" />
            <GenericTooltip tooltip={<span>{location}</span>}>
              <span
                // This style needs to be applied here to avoid being lost in
                // styl transpilation
                // https://github.com/postcss/autoprefixer/issues/1141
                style={{WebkitBoxOrient: 'vertical'}}
                className="location-description">
                {location}
              </span>
            </GenericTooltip>
          </div>
        </div>
      </div>
    );
  }
}

UpcomingAgendaHeader.propTypes = {
  horizontal: PropTypes.bool,
  otherUser: PropTypes.instanceOf(User),
  review: PropTypes.instanceOf(CoachingReview),
};
